import CustomChip from "../../../UIElements/CustomChip";
import CustomAlert from "../../../UIElements/CustomAlert";
import {
    Box,
    Card,
    CardActions,
    CardContent,
    Grid,
    Typography,
} from "@mui/material";
import { Fragment } from "react";
import { OverViewDossierType } from "@/src/types";
import { getColorByDossierStatus } from "../utils";
import DownloadBtn from "../../../UIElements/DownloadBtn";
import { downloadCertificateLabelBtn } from "../../../../consts";
import PaymentBoutton from "../../../UIElements/PaymentBoutton";

type OverViewDossierProps = {
    overViewDossierInfo: OverViewDossierType;
};

export default function OverViewDossier({
    overViewDossierInfo,
}: OverViewDossierProps) {
    const {
        content,
        actions,
        dossierId,
        statusCode,
        _dossierStatusColors,
        showDownloadCertificateBtn,
        onPaymentClick,
        disablePaymentBtn,
        isPayed,
        hidePaymentBtn,
        commitmentsCompleted,
        institutionalAffiliation,
    } = overViewDossierInfo;

    const dossierStatusColors =
        _dossierStatusColors ??
        (statusCode
            ? getColorByDossierStatus(statusCode)
            : { border: "#FF900D", background: "#FFE9CF" });

    const card = (
        <Fragment>
            <Box
                sx={{
                    display: "flex",
                    // height: "147px",
                    //height: "16.63vh",
                    flexDirection: "column",

                    alignItems: "flex-start",
                    flexShrink: 0,
                    flex: "1 0 0",
                    gap: "2rem",
                    width: "100%",
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        // height: "147px",
                        //height: "16.63vh",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        flexShrink: 0,
                        alignSelf: "stretch",
                        gap: "1rem",
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "2rem",
                            flex: "1 0 0",
                            width: "100%",
                        }}
                    >
                        {overViewDossierInfo.alertText ? (
                            <CustomAlert
                                variant="outlined"
                                severity="info"
                                label={overViewDossierInfo.alertText}
                                sx={{
                                    display: "flex",
                                    padding: "1rem",
                                    alignItems: "center",
                                    borderRadius: "0.75rem",
                                    border: "1px solid #FF900D",
                                    borderColor: "#FF900D",
                                    width: "-webkit-fill-available",
                                    ".MuiAlert-icon": {
                                        width: "1.25rem",
                                        height: "1.25rem",
                                        color: "#FF900D",
                                    },
                                    ".MuiAlert-message": {
                                        fex: "1 0 0",
                                        color: "#023",
                                        fontFamily: "Roboto",
                                        fontSize: "0.875rem",
                                        fontStyle: "normal",
                                        fontWeight: 400,
                                        lineHeight: "120%",
                                    },
                                }}
                            />
                        ) : null}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: "1.5rem",
                                alignSelf: "stretch",
                            }}
                        >
                            <CardContent
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    gap: "1.5rem",
                                    padding: 0,
                                    alignSelf: "stretch",
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "1rem",

                                        alignSelf: "stretch",
                                    }}
                                >
                                    <Grid
                                        container
                                        spacing={1.5}
                                        sx={{
                                            "@media (min-width: 900px)": {
                                                maxWidth: "100%",
                                            },
                                        }}
                                    >
                                        <Grid
                                            item
                                            xs={12}
                                            md={6}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                gap: "1.5rem",
                                                alignSelf: "stretch",
                                                width: "100%",
                                                "@media (min-width: 900px)": {
                                                    maxWidth: "100%",
                                                },
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                    // alignItems: "flex-start",
                                                    // alignSelf: "stretch",
                                                    gap: "0.5rem",
                                                }}
                                            >
                                                <CustomChip
                                                    sx={{
                                                        display: "flex",
                                                        height: "1.5rem",
                                                        justifyContent:
                                                            "center",
                                                        alignItems: "center",
                                                        borderRadius: "1.25rem",
                                                        border: `1x solid ${dossierStatusColors.border}`,
                                                        background: `${dossierStatusColors.background}`,
                                                        borderColor: `${dossierStatusColors.border}`,
                                                        ".MuiChip-label": {
                                                            color: "#023",
                                                            textAlign: "center",
                                                            fontFamily:
                                                                "Roboto",
                                                            fontSize: "0.75rem",
                                                            fontStyle: "normal",
                                                            fontWeight: "500",
                                                            lineHeight:
                                                                "normal",
                                                        },
                                                    }}
                                                    label={
                                                        dossierStatusColors?.status ??
                                                        overViewDossierInfo.status
                                                    }
                                                />

                                                {commitmentsCompleted !==
                                                    null &&
                                                commitmentsCompleted !==
                                                    undefined ? (
                                                    <Typography
                                                        sx={{
                                                            color: "#005499",
                                                            textAlign: "left",
                                                            textEdge: "cap",
                                                            fontFamily:
                                                                "Roboto",
                                                            fontSize:
                                                                "0.875rem",
                                                            fontStyle: "normal",
                                                            fontWeight: "500",
                                                            lineHeight:
                                                                "normal",
                                                            width: "100%",
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                        }}
                                                    >
                                                        {commitmentsCompleted}
                                                        {"%"}
                                                    </Typography>
                                                ) : null}

                                                {!hidePaymentBtn ? (
                                                    <PaymentBoutton
                                                        onClick={onPaymentClick}
                                                        isPayed={isPayed}
                                                        disabled={
                                                            disablePaymentBtn
                                                        }
                                                    />
                                                ) : null}

                                                {/* here  */}
                                            </Box>
                                        </Grid>
                                        <Grid
                                            xs={12}
                                            item
                                            sm={6}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "space-between",
                                                gap: "1.5rem",
                                                "@media (min-width: 900px)": {
                                                    maxWidth: "100%",
                                                },
                                            }}
                                        >
                                            {institutionalAffiliation ? (
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        // flexDirection: "column",
                                                        alignItems:
                                                            "flex-start",
                                                        gap: "1rem",
                                                        alignSelf: "stretch",
                                                    }}
                                                >
                                                    {institutionalAffiliation.network ? (
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection:
                                                                    "column",
                                                                alignItems:
                                                                    "flex-start",
                                                                gap: "0.5rem",
                                                                alignSelf:
                                                                    "stretch",
                                                                flex: "1 0 0",
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    color: "#555A5D",

                                                                    fontFamily:
                                                                        "Roboto",
                                                                    fontSize:
                                                                        "0.875rem",
                                                                    fontStyle:
                                                                        "normal",
                                                                    fontWeight: 400,
                                                                    lineHeight:
                                                                        "normal",
                                                                    alignSelf:
                                                                        "stretch",
                                                                }}
                                                            >
                                                                Réseau
                                                                d'appartenance
                                                            </Typography>
                                                            <Typography
                                                                variant="h1"
                                                                sx={{
                                                                    color: "#555A5D",

                                                                    fontFamily:
                                                                        "Roboto",
                                                                    fontSize:
                                                                        "1rem",
                                                                    fontStyle:
                                                                        "normal",
                                                                    fontWeight: 500,
                                                                    lineHeight:
                                                                        "normal",
                                                                    alignSelf:
                                                                        "stretch",
                                                                }}
                                                            >
                                                                <b>
                                                                    {
                                                                        institutionalAffiliation.network
                                                                    }
                                                                </b>
                                                            </Typography>
                                                        </Box>
                                                    ) : null}
                                                    {institutionalAffiliation.region ? (
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection:
                                                                    "column",
                                                                alignItems:
                                                                    "flex-start",
                                                                gap: "0.5rem",
                                                                alignSelf:
                                                                    "stretch",
                                                                flex: "1 0 0",
                                                            }}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    color: "#555A5D",

                                                                    fontFamily:
                                                                        "Roboto",
                                                                    fontSize:
                                                                        "0.875rem",
                                                                    fontStyle:
                                                                        "normal",
                                                                    fontWeight: 400,
                                                                    lineHeight:
                                                                        "normal",
                                                                    alignSelf:
                                                                        "stretch",
                                                                }}
                                                            >
                                                                Région
                                                                d'appartenance
                                                            </Typography>
                                                            <Typography
                                                                variant="h1"
                                                                sx={{
                                                                    color: "#555A5D",

                                                                    fontFamily:
                                                                        "Roboto",
                                                                    fontSize:
                                                                        "1rem",
                                                                    fontStyle:
                                                                        "normal",
                                                                    fontWeight: 500,
                                                                    lineHeight:
                                                                        "normal",
                                                                    alignSelf:
                                                                        "stretch",
                                                                }}
                                                            >
                                                                <b>
                                                                    {
                                                                        institutionalAffiliation.region
                                                                    }
                                                                </b>
                                                            </Typography>
                                                        </Box>
                                                    ) : null}
                                                </Box>
                                            ) : null}
                                        </Grid>
                                    </Grid>

                                    <Box
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "flex-start",
                                            gap: "0.25rem",
                                            alignSelf: "stretch",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color: "#005499",
                                                textAlign: "left",
                                                textEdge: "cap",
                                                fontFamily: "Roboto",
                                                fontSize: "0.875rem",
                                                fontStyle: "normal",
                                                fontWeight: "500",
                                                lineHeight: "normal",
                                                width: "100%",
                                            }}
                                        >
                                            #{dossierId}
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: "#023",
                                                fontFamily: "Roboto",
                                                fontSize: "1.25rem",
                                                fontStyle: "normal",
                                                fontWeight: 500,
                                                lineHeight: "normal",
                                                flex: "1 0 0",
                                            }}
                                        >
                                            {overViewDossierInfo.title}
                                        </Typography>
                                        {overViewDossierInfo.subTitle ? (
                                            <Typography
                                                sx={{
                                                    color: "#023",
                                                    fontFamily: "Roboto",
                                                    fontSize: "1rem",
                                                    fontStyle: "normal",
                                                    fontWeight: 400,
                                                    lineHeight: "normal",
                                                }}
                                            >
                                                {overViewDossierInfo.subTitle}
                                            </Typography>
                                        ) : null}
                                    </Box>
                                </Box>
                                {content}
                            </CardContent>
                            <CardActions
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "1rem",
                                    padding: 0,
                                    width: "100%",
                                    flexDirection: "column",
                                    "&.MuiCardActions-root>:not(:first-of-type)":
                                        {
                                            marginLeft: 0,
                                        },
                                }}
                            >
                                {actions &&
                                actions?.downloadCertificate &&
                                showDownloadCertificateBtn ? (
                                    <DownloadBtn
                                        label={downloadCertificateLabelBtn}
                                        customsx={{
                                            margin: 0,
                                            // float: "right",
                                            // marginLeft: "1rem",
                                            width: "100%",
                                        }}
                                        onClick={async () => {
                                            if (
                                                dossierId &&
                                                actions &&
                                                actions?.downloadCertificate
                                            ) {
                                                await actions?.downloadCertificate(
                                                    dossierId
                                                );
                                            }
                                        }}
                                    />
                                ) : null}
                                {actions?.edit}
                            </CardActions>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Fragment>
    );

    return (
        <Card
            variant="outlined"
            sx={{
                display: "flex",
                // height: "195px",
                padding: "1.5rem",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2rem",
                alignSelf: "stretch",
                borderRadius: "1.5rem",
                background: " #FFF",

                /* Ombre card */
                boxShadow: "0px 4px 30px 0px #E3E6E8",
            }}
        >
            {card}
        </Card>
    );
}
